var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceCrmcomponent = function SvgWorkspaceCrmcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.625 16c0 .255-.023.495-.053.735l1.583 1.238c.142.112.18.315.09.48l-1.5 2.595a.366.366 0 0 1-.458.165l-1.867-.75c-.39.292-.81.547-1.268.735l-.285 1.987a.366.366 0 0 1-.367.315h-3a.366.366 0 0 1-.368-.315l-.285-1.987a5.48 5.48 0 0 1-1.267-.736l-1.868.75a.377.377 0 0 1-.457-.165l-1.5-2.595a.378.378 0 0 1 .09-.48l1.582-1.237a5.948 5.948 0 0 1-.052-.735c0-.248.022-.495.052-.735l-1.582-1.238a.37.37 0 0 1-.09-.48l1.5-2.595c.09-.165.285-.232.457-.165l1.868.75c.39-.292.81-.547 1.267-.735l.285-1.987A.366.366 0 0 1 14.5 8.5h3c.187 0 .345.135.367.315l.285 1.988a5.48 5.48 0 0 1 1.268.734l1.867-.75c.165-.06.368 0 .458.165l1.5 2.595a.378.378 0 0 1-.09.48l-1.583 1.238c.03.24.053.48.053.735Zm-8.25 0A2.628 2.628 0 0 0 16 18.625 2.628 2.628 0 0 0 18.625 16 2.628 2.628 0 0 0 16 13.375 2.628 2.628 0 0 0 13.375 16Z",
    fill: "#fff"
  })));
};
export default SvgWorkspaceCrmcomponent;